"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
var _objectSpread2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _customer = require("@/api/customer");
var _member = require("@/api/member");
var _initStore = require("@/store/initStore");
var _vuePropertyDecorator = require("vue-property-decorator");
var ApproveModal = /*#__PURE__*/function (_Vue) {
  function ApproveModal() {
    var _this;
    (0, _classCallCheck2.default)(this, ApproveModal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, ApproveModal, [].concat(args));
    (0, _defineProperty2.default)(_this, "$refs", void 0);
    (0, _defineProperty2.default)(_this, "visible", false);
    (0, _defineProperty2.default)(_this, "form", {});
    (0, _defineProperty2.default)(_this, "status", "approve");
    (0, _defineProperty2.default)(_this, "loadingButton", false);
    (0, _defineProperty2.default)(_this, "ranks", []);
    (0, _defineProperty2.default)(_this, "rules", {
      customerRankId: {
        required: true,
        message: "Field is required",
        trigger: "submit"
      }
    });
    return _this;
  }
  (0, _inherits2.default)(ApproveModal, _Vue);
  return (0, _createClass2.default)(ApproveModal, [{
    key: "created",
    value: function created() {
      _initStore.customerRankStore.fetchData();
    }
  }, {
    key: "approveData",
    value: function () {
      var _approveData = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return this.$confirm("Confirm approve this member?", "Warning", {
                cancelButtonText: "No",
                confirmButtonText: "Approve",
                type: "warning"
              });
            case 3:
              this.loadingButton = true;
              _context.next = 6;
              return _member.memberApi.approve(this.form.id, {
                customerRankId: this.form.customerRankId
              });
            case 6:
              this.$notify.success({
                title: "Approve memeber",
                message: "Successfully"
              });
              this.visible = false;
              this.$emit("submit:success");
            case 9:
              _context.prev = 9;
              this.loadingButton = false;
              return _context.finish(9);
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0,, 9, 12]]);
      }));
      function approveData() {
        return _approveData.apply(this, arguments);
      }
      return approveData;
    }()
  }, {
    key: "updateData",
    value: function () {
      var _updateData = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              this.loadingButton = true;
              _context2.next = 4;
              return _customer.customerApi.update(this.form.id, {
                customer: this.form,
                customerRankId: this.form.customerRankId
              });
            case 4:
              this.$notify.success({
                title: "Update memeber",
                message: "Successfully"
              });
              this.visible = false;
              this.$emit("submit:success");
            case 7:
              _context2.prev = 7;
              this.loadingButton = false;
              return _context2.finish(7);
            case 10:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0,, 7, 10]]);
      }));
      function updateData() {
        return _updateData.apply(this, arguments);
      }
      return updateData;
    }()
  }, {
    key: "handleApprove",
    value: function handleApprove(data) {
      var _this2 = this;
      this.form = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, data), {}, {
        customerRankId: _initStore.customerRankStore.list[_initStore.customerRankStore.list.length - 1].id
      });
      this.status = "approve";
      this.visible = true;
      this.$nextTick(function () {
        _this2.$refs["form"].clearValidate();
      });
    }
  }, {
    key: "handleUpdate",
    value: function handleUpdate(data) {
      var _this3 = this;
      this.form = (0, _objectSpread2.default)({}, data);
      this.getDetail();
      this.status = "update";
      this.visible = true;
      this.$nextTick(function () {
        _this3.$refs["form"].clearValidate();
      });
    }
  }, {
    key: "getDetail",
    value: function () {
      var _getDetail = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3() {
        var res, customer;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _customer.customerApi.findOne(this.form.id);
            case 2:
              res = _context3.sent;
              customer = res.data.customer;
              this.form = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, customer), {}, {
                customerRankId: customer.customerRank.id
              });
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function getDetail() {
        return _getDetail.apply(this, arguments);
      }
      return getDetail;
    }()
  }]);
}(_vuePropertyDecorator.Vue);
ApproveModal = (0, _tslib.__decorate)([_vuePropertyDecorator.Component], ApproveModal);
var _default = exports.default = ApproveModal;